import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-seo-action-detail-modal',
  templateUrl: './seo-action-detail-modal.component.html',
  styles: [`
    .modal-content-scroll {
      max-height: 70vh;
      overflow-y: auto;
    }
    .detail-section {
      margin-bottom: 20px;
    }
    .detail-label {
      font-weight: bold;
      color: #555;
      display: block;
      margin-bottom: 5px;
      text-transform: uppercase;
      font-size: 0.8rem;
    }
    .detail-value {
      white-space: pre-wrap;
      background: #f8f9fa;
      padding: 10px;
      border-radius: 4px;
      border-left: 4px solid #343a40;
    }
  `]
})
export class SeoActionDetailModalComponent {
  constructor(
    public dialogRef: MatDialogRef<SeoActionDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
